import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {Role, Api} from "types/models";

export interface State {
  role: Role;
  listRole: Api[];
  listApi: Api[];
  api: Api;
  isOpenModal: boolean;
}

const initialState: State = {
  role: null,
  listRole: [],
  api: null,
  listApi: [],
  isOpenModal: false,
};

export const apiRoleSlice = createSlice({
  name: "apiRole",
  initialState: initialState,
  reducers: {
    setRole: (state = initialState, action: PayloadAction<any>) => {
      return {...state, role: action.payload};
    },
    setListRole: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listRole: action.payload};
    },
    setApi: (state = initialState, action: PayloadAction<any>) => {
      return {...state, api: action.payload};
    },
    setListApi: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listApi: action.payload};
    },
    setIsOpenModal: (state = initialState, action: PayloadAction<any>) => {
      return {...state, isOpenModal: action.payload};
    },
  },
});

export const {setRole, setApi, setListApi, setListRole, setIsOpenModal} =
  apiRoleSlice.actions;

export default apiRoleSlice.reducer;
